import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SITE_URL = 'https://msmecenter.com';

export function SEO({
  title = "MSMECenter – India's Most Trusted MSME Platform",
  description = "India's all-in-one digital platform for MSMEs. GST registration, business loans, compliance, digital marketing, and more.",
  canonical,
  ogImage = `${SITE_URL}/logo.png`,
  schema = null,
  noindex = false
}) {
  // Falls back to the actual current path when a page doesn't pass one
  // explicitly, so every page gets a correct, unique canonical URL instead
  // of silently pointing at the homepage.
  const { pathname } = useLocation();
  let normalizedPath = pathname;
  if (normalizedPath !== '/' && normalizedPath.endsWith('/')) {
    normalizedPath = normalizedPath.slice(0, -1);
  }
  const resolvedCanonical = canonical || `${SITE_URL}${normalizedPath.toLowerCase()}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      
      {/* Canonical Link */}
      <link rel="canonical" href={resolvedCanonical} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={resolvedCanonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={resolvedCanonical} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Indexing */}
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Structured Data */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
}
